(function () {
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });
  document.querySelectorAll('[data-v2-buy-tier]').forEach(button => {
    button.addEventListener('click', function () {
      const tier = this.dataset.v2BuyTier;
      if (tier === 'exclusive') {
        if (typeof v18ModalOpen === 'function') v18ModalOpen('inquiry');
        else document.querySelector('#contact')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
        return;
      }
      try {
        if (typeof activeLicense !== 'undefined' && Array.isArray(LICENSES)) {
          const tierIdx = LICENSES.findIndex(item => item.key === tier);
          if (tierIdx >= 0) activeLicense = tierIdx;
        }
        if (typeof addToCart === 'function' && typeof activeIdx !== 'undefined') addToCart(activeIdx, tier);
        if (typeof openCart === 'function') openCart();
      } catch (err) {
        console.warn('[J.REDD v2] Unable to add selected tier', err);
      }
    });
  });
})();

